module.exports = __webpack_public_path__ + "img/logo-tusdata-s.b87ff0bc.png";